/* --------------------------- Config & Constants --------------------------- */

const KUJI_ASSET_URL = 'https://cdn.shopify.com/s/files/1/0728/0410/6425/files/';
const RAF_ASSET_URL  = 'https://cdn.shopify.com/s/files/1/0650/2019/9164/files/';

const KUJI_MIN_CENTS = 0;   // 5000 = $50.00
const KUJI_MAX_CENTS = 300000; // $3,000

const SUPPORTED_CURRENCIES = new Set(['NZD','USD','CAD','GBP','EUR','AUD']);

const kuji = window.kuji || {};
const kujiSelectors = kuji.selectors || {};
const kujiProduct = kuji.product || null;
let kujiStatus = String(kuji.status || '') === "ACTIVE";
const kujiMerchant   = kuji.shop_name ? String(kuji.shop_name) : '';
const merchantNameHandle = kujiMerchant.toLowerCase().replace(/ /g, '-');
const merchantHandle = String(window.Shopify?.shop || merchantNameHandle)
	.toLowerCase()
	.replace(/\.myshopify\.com$/i, '');
const kujiMedia      = Array.isArray(kuji.media) ? kuji.media : [];
const kujiCheckoutMode = merchantHandle === 'nakie-goods' ? 'stripe' : 'shopify';
const kujiShowSampleCheckoutState = true;
//const kujiStripePublishableKey = 'pk_live_51LF9oFCAxCLLwI7ZC4CPtCjBmiYajg09VYXYgI599EIquROoS8X0oZmfeZ99VzkTFwBeGZHMqrrOOcKWBoTyqj2d00Hkee3K86';
const kujiStripePublishableKey = 'pk_test_51LF9oFCAxCLLwI7ZtST3lOYngyf611UbHkndKZpsthy6KPCGmpBMHDcCkNrAfSR09A2D45FrpG3sQ7iFxXayaSbP000kEVTPG0';


const kujiSearchParams = new URLSearchParams(window.location.search);
const kujiPreview = Object.fromEntries(kujiSearchParams.entries());
let kujiProductTargetCounter = 0;

const isDesignMode = !!(window.Shopify && window.Shopify.designMode);

/* ------------------------------ Cookies ---------------------------------- */

const Cookies = {
	get: (name) => document.cookie
		.split(';')
		.map(s=>s.trim())
		.find(c => c.startsWith(name+'='))?.split('=')[1] || '',
	set: (name, value, days=30) => {
		const d = new Date(Date.now() + days*864e5).toUTCString();
		document.cookie = `${name}=${value}; expires=${d}; path=/; SameSite=Lax`;
	},
	delete: (name) => {
		document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
	}
};

function kujiAttributionSource() {
	return Cookies.get('kuji-preview') == 'true' ? 'a' : 'm';
}

/* ----------------------- Third-party guards/helpers ----------------------- */

const safeMP = (name, props) => { try { window.mixpanel?.track?.(name, props); } catch(_){} };
const safeGAEvent = (action, label) => {
	try { window.ga?.('send', { hitType:'event', eventCategory:'kuji', eventAction:action, eventLabel:label }); } catch(_){}
	try { window.gtag?.('event','kuji',{ Action:action, Label:label }); } catch(_){}
};

/* ---------------------------- Currency & X copy --------------------------- */

const kujiCartCurrency = (Cookies.get('cart_currency') || '').toUpperCase();

const kujiXRaw = (typeof kuji.discount_multiple !== 'undefined' && kuji.discount_multiple !== '') ? String(kuji.discount_multiple) : '3';
const KUJI_X = kujiXRaw.includes('%')
	? { type: 'percent', value: parseFloat(kujiXRaw) }  // e.g. "22.5%" -> 22.5
	: { type: 'multiplier', value: Number(kujiXRaw) || 3 };

const kujiXText = (() => {
	if (KUJI_X.type === 'multiplier') {
		if (KUJI_X.value === 3) return 'triple';
		if (KUJI_X.value > 3)   return `${KUJI_X.value} times`;
		return 'double';
	}
	return KUJI_X.value >= 22.5 ? 'a 20%-50%' : 'a 10%-30%';
})();

const kujiDiscountText = (() => {
	if (KUJI_X.type === 'percent') {
		return KUJI_X.value >= 22.5 ? 'a 20%-50%' : 'a 10%-30%';
	}
	return `${5 * KUJI_X.value}%`;
})();

const kujiWinRatio = String(kuji.win_ratio || '50'); // '50' or '60'

/* -------------------------- Popup asset selection ------------------------- */
const popupBgDefault = 'https://cdn.shopify.com/s/files/1/0650/2019/9164/files/merchant-raflin-card_800x.jpg?v=1698100225'

let popupBg = kujiMedia.find(u => u.includes('-primary.png'))?.replace('.png', '_1000x.png') || popupBgDefault;
const popupIcon = 'https://cdn.shopify.com/s/files/1/0728/0410/6425/files/KUJI_Icon_Lilac.png?v=1757369917';

const kujiButtonText = typeof window.kuji_button_text !== 'undefined' ? String(window.kuji_button_text) : 'WIN IT NOW';
const KujiLogoSmall = `${RAF_ASSET_URL}kuji_logo_60x.png`; // 60x small logo for buttons


/* ----------------------------- AB Assignment ----------------------------- */

function ensureABAssigned() {
	if (kujiPreview.kuji === 'true') {
		kujiStatus = true
		Cookies.set('kuji-ab', '1');
		Cookies.set('kuji-preview', 'true');
		return;
	}

	let ab = Cookies.get('kuji-ab');
	if (ab === '' && kujiStatus) {
		const p = (typeof window.kuji_ab === 'number' && window.kuji_ab >= 0 && window.kuji_ab <= 1) ? window.kuji_ab : 1;
		ab = Math.random() < p ? '1' : '0';
		Cookies.set('kuji-ab', ab, 30);
		safeMP('A/B Split', { Action:'Test Assigned', Value: ab==='1'?'With kuji':'Without kuji', Merchant: merchantHandle });
	}
}
ensureABAssigned();

/* ----------------------------- Mixpanel init ----------------------------- */

(function initMixpanel() {
	if (typeof window.kuji_tracking_id === 'undefined') return;
	if (window.__kuji_mp_init__) return;
	window.__kuji_mp_init__ = true;

	(function (f, b) { if (!b.__SV) { var e, g, i, h; window.mixpanel = b; b._i = []; b.init = function (e, f, c) { function g(a, d) { var b = d.split("."); 2 == b.length && ((a = a[b[0]]), (d = b[1])); a[d] = function () { a.push([d].concat(Array.prototype.slice.call(arguments, 0))); }; } var a = b; "undefined" !== typeof c ? (a = b[c] = []) : (c = "mixpanel"); a.people = a.people || []; a.toString = function (a) { var d = "mixpanel"; "mixpanel" !== c && (d += "." + c); a || (d += " (stub)"); return d; }; a.people.toString = function () { return a.toString(1) + ".people (stub)"; }; i = "disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" "); for (h = 0; h < i.length; h++) g(a, i[h]); var j = "set set_once union unset remove delete".split(" "); a.get_group = function () { function b(c) { d[c] = function () { call2_args = arguments; call2 = [c].concat(Array.prototype.slice.call(call2_args, 0)); a.push([e, call2]); }; } for ( var d = {}, e = ["get_group"].concat( Array.prototype.slice.call(arguments, 0)), c = 0; c < j.length; c++) b(j[c]); return d; }; b._i.push([e, f, c]); }; b.__SV = 1.2; e = f.createElement("script"); e.type = "text/javascript"; e.async = !0; e.src = "undefined" !== typeof MIXPANEL_CUSTOM_LIB_URL ? MIXPANEL_CUSTOM_LIB_URL : "file:" === f.location.protocol && "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//) ? "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js" : "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js"; g = f.getElementsByTagName("script")[0]; g.parentNode.insertBefore(e, g); } })(document, window.mixpanel || []);
	try { window.mixpanel.init(window.kuji_tracking_id, { debug:true, track_pageview:false, persistence:'localStorage' }); } catch(_){}
})();

/* ------------------------------- FX Helpers ------------------------------- */

function fadeIn(element, display) {
	if (!element) return;
	let op = 0.1;
	element.style.display = display;
	element.style.opacity = '0';
	const timer = setInterval(() => {
		if (op >= 1) { clearInterval(timer); op = 1; }
		element.style.opacity = String(op);
		op += op * 0.1;
	}, 10);
}

function fadeOut(element) {
	if (!element) return;
	let op = 1;
	const timer = setInterval(() => {
		if (op <= 0.1) {
			clearInterval(timer);
			element.style.display = 'none';
			element.style.opacity = '0';
			return;
		}
		element.style.opacity = String(op);
		op -= op * 0.1;
	}, 10);
}

function setTextAllIn(sel, val) {
	document.querySelectorAll(sel).forEach(el => el.textContent = String(val));
}

/* ----------------------------- Product CTA Variants ----------------------------- */

const PRODUCT_CTA_VARIANTS = [
	'default',
	'win_for_price',
	'kuji_for_price',
];

function formatTicketPrice(ticketValue) {
	return ticketValue < 30 ? ticketValue.toFixed(2) : String(ticketValue);
}

function getNearestProductForm(el) {
	let node = el;
	while (node && node !== document.documentElement) {
		if (node.matches && node.matches('form[action*="/cart/add"]')) return node;
		node = node.parentElement;
	}
	return null;
}

function getSelectedVariantId(form) {
	if (!form) return null;

	const input =
		form.querySelector('input[name="id"]') ||
		form.querySelector('select[name="id"]');

	if (!input || !input.value) return null;
	return String(input.value);
}

function getNearestQuantityInput(button, form = null) {
	let selectors = 'input[name="quantity"], select[name="quantity"]';

	const quantityInput = form?.querySelector(selectors);
	if (quantityInput) return quantityInput;

	// If qty input is outside of the form, we'll keep checking parents to find closest input
	let node = form?.parentElement || button?.parentElement;
	while (node && node !== document.documentElement) {
		const input = node.querySelector?.(selectors);
		if (input) return input;
		node = node.parentElement;
	}

	return null;
}

function getSelectedQuantity(button, form) {
	const input = getNearestQuantityInput(button, form);
	if (!input) return 1;

	const quantity = Number(input?.value || 1);

	if (!Number.isFinite(quantity) || quantity <= 0) return 1;
	return quantity;
}

function getConfiguredProductTarget(button) {
	const widget = button?.closest?.('.kuji-widget-product');
	const targetId = widget?.dataset?.kujiProductTargetId;
	if (!targetId) return null;

	return document.querySelector(`[data-kuji-product-target-id="${targetId}"]`);
}

function getKujiProductVariantById(variantId) {
	const variants = Array.isArray(kujiProduct?.variants)
		? kujiProduct.variants
		: [];

	return variants.find((variant) => String(variant.id) === String(variantId)) || null;
}

function canUseProductCtaExperiment(button) {
	const form = getNearestProductForm(button);

	const selectedVariantId =
		getSelectedVariantId(form) ||
		(kujiProduct?.selectedVariantId ? String(kujiProduct.selectedVariantId) : null);

	if (!selectedVariantId) return null;

	const variant = getKujiProductVariantById(selectedVariantId);
	if (!variant) return null;

	const quantity = getSelectedQuantity(button, form);
	const priceCents = Number(variant.price || 0) * quantity;
	if (!priceCents) return null;

	const calc = calculateTicket(priceCents);
	if (!calc?.widgetsEnabled) return null;

	return {
		form,
		selectedVariantId,
		quantity,
		variant,
		calc,
	};
}


function resetProductButton(button) {
	if (!button) return;

	button.dataset.kujiCtaReady = 'false';
	delete button.dataset.kujiTicketPrice;
	delete button.dataset.kujiVariantId;
	delete button.dataset.kujiQuantity;

	button.innerHTML = `
		<span class="buy-now">WIN IT NOW</span> <span class="small-with">with</span>
		<img loading="lazy" width="28" height="12" src="${KujiLogoSmall}" alt="kuji logo">
	`;
}

function updateProductButton(button) {
	if (!button) return;

	const context = canUseProductCtaExperiment(button);
	const productCtaVariant = String(kuji.cta_variant ?? 'test');

	// If we can't safely resolve pricing context, keep the default copy and
	// avoid sending experiment-specific analytics dimensions.
	if (!context) {
		resetProductButton(button);
		return;
	}

	// "test" means randomized CTA mode. The other values force a specific CTA
	// version and intentionally stay out of the randomized test analytics.
	const isRandomizedMessaging = productCtaVariant === 'test';
	if (isRandomizedMessaging && !button.dataset.kujiMessageVariant) {
		const index = Math.floor(Math.random() * PRODUCT_CTA_VARIANTS.length);
		button.dataset.kujiMessageVariant = PRODUCT_CTA_VARIANTS[index];
	}

	const variantKey = isRandomizedMessaging
		? button.dataset.kujiMessageVariant
		: productCtaVariant;
	const ticketPrice = formatTicketPrice(context.calc.ticket);

	button.dataset.kujiMessageVariant = variantKey;
	button.dataset.kujiCtaReady = isRandomizedMessaging ? 'true' : 'false';
	button.dataset.kujiTicketPrice = ticketPrice;
	button.dataset.kujiVariantId = context.selectedVariantId;
	button.dataset.kujiQuantity = String(context.quantity);

	if (variantKey === 'default') {
		button.innerHTML = `
			<span class="buy-now">WIN IT NOW</span> <span class="small-with">with</span>
			<img loading="lazy" width="28" height="12" src="${KujiLogoSmall}" alt="kuji logo">
		`;
		return;
	}

	if (variantKey === 'win_for_price') {
		button.innerHTML = `
			<span class="buy-now">WIN IT NOW</span> <span class="small-with">for</span>
			<span class="kuji-price-wrap">$<span class="kuji-price">${ticketPrice}</span></span>
		`;
		return;
	}

	button.innerHTML = `
		<span class="buy-now">KUJI IT NOW</span> <span class="small-with">for</span>
		<span class="kuji-price-wrap">$<span class="kuji-price">${ticketPrice}</span></span>
	`;
}

/* ----------------------------- Cart Utilities ----------------------------- */

async function getCart() {
	const base = (window.Shopify?.routes?.root || '/');
	const res = await fetch(`${base}cart.js`, { credentials: 'same-origin' });
	if (!res.ok) throw new Error(`cart.js ${res.status}`);
	return res.json();
}

/* ------------------------- Ticket Price Calculator ------------------------ */

function customCeil(num, digits) {
	const factor = 10 ** digits;
	return Math.ceil(num * factor) / factor;
}

// Returns: { ticket: number (dollars), minCartCents: number, widgetsEnabled: boolean, percentCopy: string }
function calculateTicket(cartTotalCents) {
	// Effective 5% product/cart price
	let WR = 20;
	// $500 should use 2.5% WR
	if (kujiWinRatio === '60' || cartTotalCents > 50000 ) {
		WR = 40;
	}
	const markup = 0

	let ticketDollars = customCeil((cartTotalCents / (WR * 100) + markup), 1);
	if (ticketDollars > 9.99 && ticketDollars <= 30) ticketDollars = Math.ceil(ticketDollars * 2) / 2;
	else if (ticketDollars > 30 && ticketDollars <= 99) ticketDollars = Math.ceil(ticketDollars);
	else if (ticketDollars > 99 && ticketDollars <= 500) ticketDollars = 5 * Math.ceil(ticketDollars / 5);

	if (cartTotalCents > KUJI_MAX_CENTS) return { widgetsEnabled:false };

	const relief = (ticketDollars < 10) ? (WR/10) : (ticketDollars <= 30 ? (WR/2) : WR);
	const minCartCents = Math.max(0, Math.round(((ticketDollars * WR) - relief) * 100));

	const percentCopy = kujiDiscountText;

	return { ticket: ticketDollars, minCartCents, widgetsEnabled:true, percentCopy };
}

/* --------------------------- Kuji URL Builder ----------------------------- */

function buildKujiUrl(cart) {
	const localeMap = { NZD:'en-nz', USD:'en-us', CAD:'en-ca', GBP:'en-gb', EUR:'en-eu', AUD:'' };
	const geo = localeMap[kujiCartCurrency] || '';
	const base = new URL(`https://kujinow.com/${geo ? geo + '/' : ''}cart`);

	// TODO: When cart lines include selling plan data, keep the normal permalink flow
	// only for non-subscription carts. Subscription carts should switch to a separate
	// Ajax cart-builder flow that posts `id`, `quantity`, and normalized `selling_plan`.
	const items = cart.items.map(it => `${it.variant_id}:${it.quantity}`).join(',');
	const products = cart.items.map(it => it.title.replaceAll(',', '')).join(',');

	const x = String(KUJI_X.value); // multiplier or percent number (no % symbol)

	base.search = new URLSearchParams({
		h: merchantHandle,
		m: kujiMerchant,
		t: String(cart.total_price),  // cents
		s: kujiAttributionSource(),
		x,
		r: kujiWinRatio,
		i: items,
		p: products
	}).toString();

	return base.toString();
}

/* ------------------------------ Popup HTML ------------------------------- */

const RafLogo = `
	<img loading="lazy" width="200" height="51"
			 src="${RAF_ASSET_URL}kuji_logo_200x.png" alt="kuji logo"/>
`;
const RafPoweredLogo = `
	<img loading="lazy" width="200" height="111"
			 src="${KUJI_ASSET_URL}kuji_powered_logo_200x.png" alt="kuji powered"/>
`;
const RafFooter = `
	<div class="kuji-footer">
		<a class="kuji-footer-logo" href="https://www.kujinow.com" target="_blank" rel="noopener">${RafPoweredLogo}</a>
		<button class="kuji-more-info" type="button">Learn More</button>
		<button class="kuji-cont-shopping" type="button" data-kuji-close="promo">Continue Shopping</button>
	</div>
`;
const RafGeneralInfo = `<p class="explain">Look out for the Kuji button while shopping to win your entire cart</p>`;

const RafSteps = `
	<div class="kuji-popup-steps">
		<div class="kuji-stps-intro kuji-show-mb">
			<h5>Shop. Click. Win Instantly</h5>
			<p>Win your purchase INSTANTLY or receive an exclusive ${kujiDiscountText} OFF discount.<br/> <strong>Every customers WINS!</strong></p>
		</div>
		<ul>
			<li class="kuji-step">
				<div class="step-img kuji-show-mb">
					<img class="kuji-show-mb" loading="lazy" width="300" height="300" src="${RAF_ASSET_URL}icon-shopping_cart_small.png" alt="kuji step 1">
				</div>
				<h4>Step 1</h4>
				<h5>Shop</h5>
				<p>Shop as you always do!<br/>Add your favourite items<br/> to the cart.</p>
				<div class="kuji-step-tag">COMPLETED<span><div class="kuji-check-icon"></div></span></div>
			</li>
			<li class="kuji-step kuji-step-2">
				<div class="step-img kuji-show-mb">
					<img class="kuji-show-mb" loading="lazy" width="300" height="300" src="${RAF_ASSET_URL}icon-click_small.png" alt="kuji step 2">
				</div>
				<h4>Step 2</h4>
				<h5>Click</h5>
				<div class="kuji-hide-mb">
					<div class="kuji-btn kuji-brand-btn kuji-example kuji-hide-mb">
						<span class="buy-now">${kujiButtonText}</span> <span class="small-with">with</span>${RafLogo}
					</div>
				</div>
				<p>Click <b>“${kujiButtonText}”</b><br/> at the cart section and<br/> buy a ticket.</p>
				<div class="kuji-step-tag">PENDING<span>•••</span></div>
				<img class="kuji-you-are-here" loading="lazy" src="${RAF_ASSET_URL}you-are-here_400x.png" alt="you are here">
			</li>
			<li class="kuji-step kuji-step-3">
				<div class="step-img kuji-show-mb">
					<img loading="lazy" width="300" height="300"
							 src="${RAF_ASSET_URL}icon-card_small.png" alt="kuji step 3">
				</div>
				<h4>Step 3</h4>
				<h5>Win <span>Instantly</span></h5>
				<p>Your <b>ENTIRE CART</b><br/>or <br/> a <b>${kujiDiscountText} OFF discount</b>.</p>
				<div class="kuji-step-tag">INSTANTLY</div>
			</li>
		</ul>
	</div>
`;

/* ---------------------------- UI Construction ----------------------------- */

let kujiPopupEl, kujiPromoEl, kujiInfoEl, kujiHIWEl;
let kujiPopupInit = false;
let kujiCheckout = null;
let kujiCheckoutScriptPromise = null;
let kujiCheckoutSessionId = "";
let kujiCheckoutPollToken = "";
let kujiCheckoutPollTimer = null;
let kujiCheckoutDestroyTimer = null;
let kujiCheckoutProcessingTimer = null;

const POPUP_VARIANTS = [
	'popup_with_cart_summary',
	'popup_without_cart_summary',
];

function ensurePopupVariant() {
	if (!kujiPopupEl) return null;
	if (!kujiPopupEl.dataset.kujiPopupVariant) {
		const index = Math.floor(Math.random() * POPUP_VARIANTS.length);
		kujiPopupEl.dataset.kujiPopupVariant = POPUP_VARIANTS[index];
	}
	return kujiPopupEl.dataset.kujiPopupVariant;
}

function applyPopupVariant() {
	if (!kujiPopupEl) return;

	const popupVariant = ensurePopupVariant();
	const cartSummaryCard = kujiPopupEl.querySelector('.kuji-popup-summary-card');
	if (!cartSummaryCard) return;

	const hideCartSummary = popupVariant === 'popup_without_cart_summary';

	const setDisplay = (selector, hidden) => {
		const el = kujiPopupEl.querySelector(selector);
		if (el) el.style.display = hidden ? 'none' : '';
	};

	setDisplay('.kuji-popup-summary-card', hideCartSummary);
	setDisplay('.kuji-popup-add-more', hideCartSummary);
	setDisplay('.kuji-prizeline-footer', hideCartSummary);

	setDisplay('.kuji-prizeline-top', !hideCartSummary);
	setDisplay('.kuji-secondary-prize', !hideCartSummary);
}

function buildMainPopup() {
	if (kujiPopupInit) return;
	kujiPopupEl = document.createElement('div');
	kujiPopupEl.id = 'kuji-popup';
	kujiPopupEl.className = 'kuji-popup';

	const prizeLine = `
		<div class="winning-options">
			<ul>
				<li><p>1 in ${kujiWinRatio} chance of <strong>INSTANTLY</strong> winning <br/>your entire ${kujiMerchant} purchase.</p></li>
				<li><p>Or unlock a <span class="kuji-cart-value"></span> OFF discount<br/> <strong>Every Ticket WINS!</strong></p></li>
			</ul>
		</div>`;


	kujiPopupEl.innerHTML = `
		<div class="kuji-popup-inner">
			<button type="button" class="close-kuji-popup-x" data-kuji-close="main"></button>
			<div id="kuji-popup-content" class="popup-content">
				<div class="kuji-card-details">
					<img loading="lazy" class="kuji-merchant-logo" width="50" height="50" alt="${kujiMerchant} kuji logo" src="${popupIcon}" />
					<div class="kuji-card-details-info">
						<p><strong>${kujiMerchant}</strong></p>
						<div class="kuji-card-specs"><p>Limited time offer</p></div>
					</div>
				</div>
				<div class="kuji-feature-img">
					<img class="kuji-popup-feature-img" src="${popupBg}" alt="">
					<div class="kuji-popup-content">
						<div class="kuji-relative">
							<div class="kuji-blur"></div>
							<h5>
								<b>WIN Your Cart</b> for <span class="kuji-price-wrap">$<span class="kuji-price"></span></span>
							</h5>
						</div>
					</div>
				</div>
				<div class="kuji-stripe-panel">
					<div id="kuji-stripe-checkout"></div>
					<p class="kuji-stripe-error" hidden></p>
				</div>
				<div class="kuji-popup-padding kuji-min-cart kuji-popup-intro-panel">
					<div class="kuji-popup-card">
						<a class="kuji-buy-ticket kuji-btn kuji-brand-btn" href="#" target="_blank" rel="noopener">
							<span>WIN IT NOW</span> <span class="small-with">with</span>${RafLogo}
						</a>
						${prizeLine}
					</div>
					<!--
					<div class="kuji-popup-add-more kuji-white">
						<button type="button" class="kuji-btn" data-kuji-close="main">ADD MORE TO WIN MORE</button>
					</div>
					<div class="kuji-popup-card kuji-popup-summary-card">
						<div class="kuji-popup-cart-summary"></div>
						<div class="kuji-popup-cart-total">
							<span>Total:</span>
							<span>$<span class="kuji-cart-total"></span></span>
						</div>
						<a class="kuji-buy-ticket kuji-btn kuji-brand-btn" href="#" target="_blank" rel="noopener">
							<span>WIN IT NOW</span> <span class="small-with">for</span> <span class="kuji-price-wrap">$<span class="kuji-price"></span></span>
						</a>
					</div>
					-->
				</div>
				${RafSteps}${RafFooter}
			</div>
		</div>
	`;
	document.body.appendChild(kujiPopupEl);
	// applyPopupVariant();
	kujiPopupInit = true;
}

/* --------------------------- Gating & Core Flow --------------------------- */

// Update and re-render Kuji Popup
async function updateKuji({ prevTotal = null } = {}) {
	try {
		const cart = await getCart(); // { total_price, items, ... }
		const total = Number(cart?.total_price || 0);

		// If we passed a snapshot and total hasn’t changed yet, keep polling forever (500ms)
		if (typeof prevTotal === 'number' && !Number.isNaN(prevTotal) && total === prevTotal) {
			setTimeout(() => updateKuji({ prevTotal }), 500);
			return;
		}

		//console.log('cart',cart)

		// Proceed with UI updates once total changed (or if no prevTotal was provided)
		const calc = calculateTicket(total);
		if (!calc.widgetsEnabled) return;

		const ticketStr = calc.ticket < 30 ? calc.ticket.toFixed(2) : String(calc.ticket);

		setTextAllIn('.kuji-price', ticketStr);
		setTextAllIn('.kuji-cart-value', calc.percentCopy);
		setTextAllIn('.kuji-min-spend', (calc.minCartCents / 100).toFixed(0));
		setTextAllIn('.kuji-cart-total', (total / 100).toFixed(2) );
		// Cart summary
		const html = cart.items.map(item => {
			const image = item.featured_image?.url || '';
			const title = item.product_title || item.title;
			const variant = item.variant_title ? `<div class="variant">${item.variant_title}</div>` : '';
			const price = (item.final_line_price / 100).toFixed(2);

			return `
				<div class="kuji-cart-line" data-key="${item.key}">
					<img class="kuji-cart-line-thumb" src="${image}" alt="${title}">
					<div class="kuji-cart-line-info">
						<div class="kuji-cart-line-title">${title}<span class="kuji-cart-line-variant">${variant}</span></div>
						<div class="kuji-cart-line-qty">
							<button type="button" class="kuji-cart-line-minus"></button>
							<input type="text" value="${item.quantity}"/>
							<button type="button" class="kuji-cart-line-add"></button>
						</div>
					</div>
					<div class="kuji-cart-line-price">$${price}</div>
				</div>
			`;
		}).join('');

		// Inject cart summary into popup container
		document
		.querySelectorAll('.kuji-popup-cart-summary')
		.forEach(el => { el.innerHTML = html; });

		// Always refresh the Kuji URL
		const buttons = document.querySelectorAll('.kuji-buy-ticket');
		buttons.forEach(btn => {
			btn.setAttribute('href', buildKujiUrl(cart));
		});

		// Show popup if above minimum
		if (total >= KUJI_MIN_CENTS) {
			if (typeof kujiPopupEl !== 'undefined' && kujiPopupEl) {
				fadeIn(kujiPopupEl, 'flex');
				clearKujiButtonLoadingStates();
			}
			return;
		}

		// If we *didn’t* pass prevTotal (no recent add), you can keep the original alerts
		if (prevTotal == null) {
			if (total === 0) {
				clearKujiButtonLoadingStates();
				alert("Error adding product to cart. Make sure it’s in stock.");
				return;
			}
			clearKujiButtonLoadingStates();
			alert(`$${(KUJI_MIN_CENTS / 100).toFixed(0)} minimum cart required for kuji`);
		}
		// If prevTotal was given and we got here, the total changed but is still below min — no alert by default.
		clearKujiButtonLoadingStates();

	} catch (err) {
		console.error('updateKuji failed:', err);
		clearKujiButtonLoadingStates();
	}
}

// Quantity change on Kuji Popup cart summary:
async function kujiUpdateCartLine(key, quantity) {
	// Find the line element in the DOM
	const lineEl = document.querySelector(`.kuji-cart-line[data-key="${key}"]`);
	const priceEl = lineEl?.querySelector('.kuji-cart-line-price');

	// Add loading state
	if (priceEl) {
		priceEl.classList.add('loading');
		priceEl.dataset.original = priceEl.textContent; // optional backup
		priceEl.textContent = '';
	}

	// Send update to Shopify
	await fetch('/cart/change.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'Accept': 'application/json'
		},
		body: JSON.stringify({ id: key, quantity })
	});

	// Refresh the entire Kuji popup (this will remove loading state)
	await updateKuji();
}

// Kuji Popup Cart Summary Qty adjust:

// +/- buttons
document.addEventListener('click', async (e) => {
	const minus = e.target.closest('.kuji-cart-line-minus');
	const add   = e.target.closest('.kuji-cart-line-add');
	if (!minus && !add) return;

	const lineEl = e.target.closest('.kuji-cart-line');
	if (!lineEl) return;

	const key   = lineEl.dataset.key;
	const input = lineEl.querySelector('.kuji-cart-line-qty input');

	let qty = Number(input.value) || 0;

	qty = minus ? qty - 1 : qty + 1;
	if (qty < 0) qty = 0;

	await kujiUpdateCartLine(key, qty);
});

//  Qty input change
document.addEventListener('change', async (e) => {
	const input = e.target.closest('.kuji-cart-line-qty input');
	if (!input) return;

	const lineEl = input.closest('.kuji-cart-line');
	if (!lineEl) return;

	const key = lineEl.dataset.key;
	let qty   = Number(input.value);
	if (isNaN(qty) || qty < 0) qty = 0;

	await kujiUpdateCartLine(key, qty);
});


/* ------------------------------ Open/Close ------------------------------- */

function openKuji(sourceLabel = 'Cart', { prevTotal = null } = {}) {
	buildMainPopup();
	if (kujiPopupEl) {
		if (kujiCheckoutDestroyTimer) {
			clearTimeout(kujiCheckoutDestroyTimer);
			kujiCheckoutDestroyTimer = null;
		}
		if (kujiCheckoutProcessingTimer) {
			clearTimeout(kujiCheckoutProcessingTimer);
			kujiCheckoutProcessingTimer = null;
		}
		kujiPopupEl.classList.remove('kuji-stripe-active', 'kuji-stripe-processing', 'kuji-stripe-result');
		const sampleMountEl = kujiPopupEl.querySelector('#kuji-stripe-checkout');
		if (sampleMountEl) sampleMountEl.innerHTML = '';
	}
	if (!isDesignMode) updateKuji({ prevTotal }); // poll only if prevTotal given
	Cookies.set('kuji-seen', 'yes', 300);
	safeGAEvent('Open Popup', sourceLabel);
	safeMP('Popup Viewed', {
		Source: sourceLabel,
		Variable: kujiButtonText,
		Merchant: merchantHandle
	});
}

// Alias to support legacy inline onclick in your provided markup
window.openkuji = function(action, label, recheck) {
	// action is unused in the new flow; we keep it for compatibility
	openKuji(label || 'Cart', { recheck: Boolean(recheck) });
};

function openKujiPromo(label='Promo') {
	if (!kujiPromoEl) {
		kujiPromoEl = document.createElement('div');
		kujiPromoEl.id = 'kuji-promo-popup';
		kujiPromoEl.className = 'kuji-popup';
		kujiPromoEl.innerHTML = `
		<div class="kuji-popup-inner step-style-alt">
			<button type="button" class="close-kuji-popup-x" data-kuji-close="promo"></button>
			<div id="kuji-popup-content" class="popup-content">
				<div class="kuji-feature-img">
					<img class="kuji-popup-feature-img" src="${popupBg}" alt="">
					<div class="kuji-popup-content">
						<div class="kuji-relative">
							<h5 class="kuji-promo-title kuji-brand-font primary">Win your <b>entire cart</b></h5>
							<div class="kuji-hide-mb">
								${RafGeneralInfo}
								<div class="kuji-btn kuji-brand-btn kuji-example">
									<span class="buy-now">${kujiButtonText}</span> <span class="small-with">with</span>${RafLogo}
								</div>
							</div>
						</div>
					</div>
					<h5 class="kuji-promo-title kuji-brand-font secondary"><b>Every ticket</b> wins instantly</h5>
				</div>
				<div class="kuji-show-mb">
					${RafGeneralInfo}
					<div class="kuji-btn kuji-brand-btn kuji-example">
						<span class="buy-now">${kujiButtonText}</span> <span class="small-with">with</span>${RafLogo}
					</div>
				</div>
				${RafSteps}${RafFooter}
			</div>
		</div>`;
		document.body.appendChild(kujiPromoEl);
	}
	fadeIn(kujiPromoEl, 'flex');
	Cookies.set('kuji-seen', 'yes', 300);
	safeGAEvent('Open Promo', label);
}

function openKujiInfo(label='Info') {
	if (!kujiInfoEl) {
		kujiInfoEl = document.createElement('div');
		kujiInfoEl.id = 'kuji-info-popup';
		kujiInfoEl.className = 'kuji-popup';
		kujiInfoEl.innerHTML = `
		<div class="kuji-popup-inner step-style-alt">
			<button type="button" class="close-kuji-popup-x" data-kuji-close="info"></button>
			<div id="kuji-popup-content" class="popup-content">
				<div class="kuji-feature-img">
					<img class="kuji-popup-feature-img" src="${popupBg}" alt="">
					<div class="kuji-popup-content"><h5>Every ticket wins</h5></div>
				</div>
				${RafSteps}${RafFooter}
			</div>
		</div>`;
		document.body.appendChild(kujiInfoEl);
	}
	fadeIn(kujiInfoEl, 'flex');
	Cookies.set('kuji-seen', 'yes', 300);
	safeGAEvent('Open Info', label);
}

function openKujiHIW(label='HIW') {
	if (!kujiHIWEl) {
		kujiHIWEl = document.createElement('div');
		kujiHIWEl.id = 'kuji-hiw-popup';
		kujiHIWEl.className = 'kuji-popup';

		const multipleLineText = `<strong>${kujiXText}</strong> the kuji ticket value in store credit</p>`;
		kujiHIWEl.innerHTML = `
		<div class="kuji-popup-inner">
			<button type="button" class="close-kuji-popup-x" data-kuji-close="hiw"></button>
			<div class="popup-content">
				<div class="hiw-content-wrapper">
					<div class="hiw-content">
						<h3>How it works?</h3>
						<h3 class="second-title">WIN your cart.</h3>
						<table><tbody>
							<tr><td><span class="step">STEP 1</span></td><td><p>Add items to your cart and select the <strong>${kujiButtonText}</strong> button</p></td></tr>
							<tr><td><span class="step" style="background:#9948ff;">STEP 2</span></td><td><p>Purchase a kuji Ticket</p></td></tr>
							<tr><td><span class="step">STEP 3</span></td><td><p><strong>WIN</strong> your <strong>ENTIRE cart</strong> <em>OR</em> ${multipleLineText}</td></tr>
							<tr><td><span class="step">STEP 4</span></td><td><p>Finalise your purchase with your <strong>automatically applied</strong> kuji discount code</p></td></tr>
						</tbody></table>
					</div>
					<div class="raf-hiw-img">
						<img loading="lazy" width="968" height="1567" alt="kuji how it works" src="${RAF_ASSET_URL}merchant_hiw_popup_800x.png">
					</div>
				</div>
			</div>
		</div>`;
		document.body.appendChild(kujiHIWEl);
	}
	fadeIn(kujiHIWEl, 'flex');
	Cookies.set('kuji-seen', 'yes', 300);
	safeGAEvent('Open HIW', label);
}

function closeKuji(el) {
	if (el === kujiPopupEl) {
		clearKujiCheckoutPoll();
		if (kujiCheckoutProcessingTimer) {
			clearTimeout(kujiCheckoutProcessingTimer);
			kujiCheckoutProcessingTimer = null;
		}
		kujiPopupEl.classList.remove('kuji-stripe-active', 'kuji-stripe-processing', 'kuji-stripe-result');

		// Let the popup close animation finish before tearing down embedded Checkout.
		if (kujiCheckoutDestroyTimer) clearTimeout(kujiCheckoutDestroyTimer);
		kujiCheckoutDestroyTimer = setTimeout(() => {
			if (kujiCheckout) {
				kujiCheckout.destroy();
				kujiCheckout = null;
			}

			const mountEl = kujiPopupEl.querySelector('#kuji-stripe-checkout');
			if (mountEl) {
				mountEl.hidden = false;
				mountEl.innerHTML = '';
			}
			kujiCheckoutSessionId = "";
			kujiCheckoutPollToken = "";
			kujiCheckoutDestroyTimer = null;
		}, 1000);
	}
	fadeOut(el);
	Cookies.set('kuji-seen', 'yes', 300);
}

function setKujiButtonLoading(button, isLoading) {
	if (!button) return;

	// Clear any previous auto-reset timer before applying a new loading state.
	if (button._kujiLoadingResetTimer) {
		clearTimeout(button._kujiLoadingResetTimer);
		button._kujiLoadingResetTimer = null;
	}

	button.classList.toggle('kuji-btn-loading', isLoading);
	button.setAttribute('aria-busy', isLoading ? 'true' : 'false');

	if (button.tagName === 'BUTTON') {
		button.disabled = isLoading;
	} else if (isLoading) {
		button.setAttribute('aria-disabled', 'true');
	} else {
		button.removeAttribute('aria-disabled');
	}

	// Popup action buttons should recover automatically if the next navigation
	// step doesn't happen immediately. This keeps the spinner from getting stuck
	// inside `#kuji-popup` after a short-lived click.
	if (isLoading && button.closest('#kuji-popup')) {
		button._kujiLoadingResetTimer = setTimeout(() => {
			if (!button.isConnected) return;
			setKujiButtonLoading(button, false);
		}, 2000);
	}
}

function clearKujiButtonLoadingStates() {
	document.querySelectorAll('.kuji-btn-loading').forEach((button) => {
		setKujiButtonLoading(button, false);
	});
}

function showKujiCheckoutError(message) {
	const errorEl = kujiPopupEl?.querySelector('.kuji-stripe-error');
	if (!errorEl) return;
	errorEl.textContent = message;
	errorEl.hidden = false;
}

function clearKujiCheckoutPoll() {
	if (!kujiCheckoutPollTimer) return;
	clearTimeout(kujiCheckoutPollTimer);
	kujiCheckoutPollTimer = null;
}

function animateKujiResultState(resultEl) {
	if (!resultEl) return;

	const prizeEl = resultEl.querySelector('[data-kuji-result-text]');
	const finalText = prizeEl?.dataset.kujiResultText || '';
	if (!prizeEl || !finalText) return;

	const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ0123456789$%';
	const finalChars = finalText.split('');
	const displayChars = finalChars.map(() => '');
	let visibleStart = finalChars.length - 1;
	let settledStart = finalChars.length;
	let randomTimer = null;
	const charAddedAt = finalChars.map(() => 0);
	const charSlideDuration = 2400;
	const charFadeDuration = 600;
	charAddedAt[visibleStart] = Date.now();

	prizeEl.style.setProperty('--kuji-result-chars', String(finalChars.length));

	const escapeHtml = (char) => {
		if (char === ' ') return '&nbsp;';
		if (char === '&') return '&amp;';
		if (char === '<') return '&lt;';
		if (char === '>') return '&gt;';
		return char;
	};

	const randomChar = () => chars[Math.floor(Math.random() * chars.length)];
	const easeOutCubic = (value) => 1 - Math.pow(1 - value, 3);

	const slidePrizeGroup = () => {
		prizeEl.style.transition = 'none';
		prizeEl.style.transform = 'translateX(-0.45em)';
		void prizeEl.offsetWidth;
		prizeEl.style.transition = 'transform 900ms cubic-bezier(0.22, 1, 0.36, 1)';
		prizeEl.style.transform = 'translateX(0)';
	};

	const randomizeVisible = () => {
		for (let index = visibleStart; index < settledStart; index += 1) {
			displayChars[index] = randomChar();
		}
	};

	const render = () => {
		const now = Date.now();

		prizeEl.innerHTML = finalChars
			.slice(visibleStart)
			.map((_, index) => {
				const finalIndex = visibleStart + index;
				const displayChar = finalIndex >= settledStart ? finalChars[finalIndex] : displayChars[finalIndex];
				const addedAt = charAddedAt[finalIndex] || now;
				const slideProgress = easeOutCubic(Math.min((now - addedAt) / charSlideDuration, 1));
				const fadeProgress = Math.min((now - addedAt) / charFadeDuration, 1);
				const opacity = fadeProgress.toFixed(3);
				const translate = ((1 - slideProgress) * -0.7).toFixed(3);

				return `<span class="kuji-result-char"><span class="kuji-result-char-inner" style="opacity:${opacity};transform:translateX(${translate}em)">${escapeHtml(displayChar)}</span></span>`;
			})
			.join('');
	};

	const settleChars = () => {
		let settleIndex = finalChars.length - 1;
		const settleDelay = Math.round(1800 / finalChars.length);

		const settleNext = () => {
			if (settleIndex < 0) {
				if (randomTimer) clearInterval(randomTimer);
				prizeEl.style.transform = 'translateX(0)';
				prizeEl.textContent = finalText;
				return;
			}

			displayChars[settleIndex] = finalChars[settleIndex];
			settledStart = settleIndex;
			render();
			settleIndex -= 1;
			setTimeout(settleNext, settleDelay);
		};

		settleNext();
	};

	randomizeVisible();
	render();
	slidePrizeGroup();

	randomTimer = setInterval(() => {
		randomizeVisible();
		render();
	}, 160);

	const addChar = () => {
		if (visibleStart <= 0) {
			settleChars();
			return;
		}

		visibleStart -= 1;
		charAddedAt[visibleStart] = Date.now();
		randomizeVisible();
		render();
		slidePrizeGroup();
		if (visibleStart <= 0) {
			settleChars();
			return;
		}

		setTimeout(addChar, 240);
	};

	setTimeout(addChar, 260);
}

function pollForTicketResult(attempt = 1) {
	clearKujiCheckoutPoll();

	kujiCheckoutPollTimer = setTimeout(async () => {
		try {
			// Ask the server whether the Stripe webhook has created the discount code yet.
			const url = new URL('https://raflin-server.onrender.com/api/stripe/ticket_status');
			url.searchParams.set('session_id', kujiCheckoutSessionId);
			url.searchParams.set('shop', merchantHandle);
			url.searchParams.set('token', kujiCheckoutPollToken);

			const response = await fetch(url.toString(), { method: 'GET' });
			const data = await response.json().catch(() => ({}));
			if (!response.ok) throw new Error(data?.error || 'Ticket status unavailable');

			if (data?.status === 'ready' && data.ticket?.discountCode) {
				clearKujiCheckoutPoll();
				if (kujiCheckoutProcessingTimer) {
					clearTimeout(kujiCheckoutProcessingTimer);
					kujiCheckoutProcessingTimer = null;
				}

				const ticket = data.ticket;
				const discountCode = String(ticket.discountCode || '');
				const checkoutUrl = new URL('/checkout', window.location.origin);
				checkoutUrl.searchParams.set('discount', discountCode);

				let discountLabel = 'your discount';
				if (ticket.prize === 'Cart') {
					try {
						discountLabel = `${new Intl.NumberFormat(undefined, {
							style: 'currency',
							currency: String(ticket.cartCurrency).toUpperCase(),
						}).format(Number(ticket.credit || 0))} OFF`;
					} catch {
						discountLabel = `$${Number(ticket.credit || 0).toFixed(2)} OFF`;
					}
				} else {
					discountLabel = `${Number.parseInt(String(ticket.discountMultiple), 10) * 5}% OFF`;
				}

				// Fade the processing state out before showing the ticket result.
				const mountEl = kujiPopupEl?.querySelector('#kuji-stripe-checkout');
				if (mountEl) {
					const resultHtml = `
						<div id="kuji-checkout-state" class="kuji-checkout-state kuji-ticket-result">
							<div class="kuji-card kuji-result-card kuji-result-prize-card">
								<img loading="lazy" class="kuji-card-bg-logo" src="https://cdn.shopify.com/s/files/1/0728/0410/6425/files/kuji_icon_light_400x.png?v=1777851177">
								<div class="kuji-result-card-content">
									<p class="kuji-ticket-eyebrow">You won</p>
									<h3 data-kuji-result-text="${discountLabel}">${discountLabel}</h3>
									<div class="kuji-ticket-code-wrap">
										<p class="kuji-ticket-code">${discountCode}</p>
										<button type="button" class="kuji-ticket-copy" aria-label="Copy discount code" data-kuji-copy-code="${discountCode}">
											<svg viewBox="0 0 24 24" aria-hidden="true">
												<rect x="9" y="9" width="10" height="10" rx="2"></rect>
												<path d="M5 15V7a2 2 0 0 1 2-2h8"></path>
											</svg>
										</button>
									</div>
								</div>
							</div>
							<div class="kuji-card kuji-result-card kuji-result-action-card">
								<div class="kuji-result-card-content">
									<a class="kuji-btn kuji-btn-black" href="${checkoutUrl.toString()}">
										<span>Apply Discount</span>
									</a>
									${ticket.prize !== 'Cart' ? `
										<button type="button" class="kuji-btn kuji-btn-white kuji-try-again">
											<span>Try Again</span>
										</button>
									` : ''}
								</div>
							</div>
						</div>
					`;
					const currentState = mountEl.querySelector('.kuji-checkout-state');
					if (currentState) currentState.classList.add('kuji-state-exiting');

					setTimeout(() => {
						kujiPopupEl?.classList.remove('kuji-stripe-processing');
						kujiPopupEl?.classList.add('kuji-stripe-result');
						mountEl.innerHTML = resultHtml;
						requestAnimationFrame(() => {
							const resultEl = mountEl.querySelector('.kuji-ticket-result');
							resultEl?.classList.add('kuji-state-visible');
							animateKujiResultState(resultEl);
						});
					}, currentState ? 260 : 0);
				}
				return;
			}

			if (attempt >= 30) {
				showKujiCheckoutError('Your payment worked, but your ticket is still being created. Please contact Kuji support.');
				return;
			}

			pollForTicketResult(attempt + 1);
		} catch (error) {
			console.error('Kuji ticket poll failed:', error);
			if (attempt >= 30) {
				showKujiCheckoutError('Your payment worked, but your ticket is still being created. Please contact Kuji support.');
				return;
			}
			pollForTicketResult(attempt + 1);
		}
	}, attempt === 1 ? 500 : 2000);
}

async function openKujiCheckout() {
	if (!kujiPopupEl) buildMainPopup();

	const panel = kujiPopupEl.querySelector('.kuji-stripe-panel');
	const mountEl = kujiPopupEl.querySelector('#kuji-stripe-checkout');
	const errorEl = kujiPopupEl.querySelector('.kuji-stripe-error');
	if (!panel || !mountEl) throw new Error('Stripe checkout container missing');

	if (errorEl) {
		errorEl.textContent = '';
		errorEl.hidden = true;
	}

	kujiPopupEl.classList.remove('kuji-stripe-processing', 'kuji-stripe-result');
	kujiPopupEl.classList.add('kuji-stripe-active');

	const cart = await getCart();
	const calc = calculateTicket(Number(cart?.total_price || 0));
	if (!calc.widgetsEnabled) throw new Error('Cart is not eligible for Kuji checkout');

	// Load Stripe.js once before mounting embedded Checkout.
	if (!window.Stripe && !kujiCheckoutScriptPromise) {
		kujiCheckoutScriptPromise = new Promise((resolve, reject) => {
			const script = document.createElement('script');
			script.src = 'https://js.stripe.com/v3/';
			script.async = true;
			script.onload = () => window.Stripe ? resolve(window.Stripe) : reject(new Error('Stripe.js did not load'));
			script.onerror = () => reject(new Error('Failed to load Stripe.js'));
			document.head.appendChild(script);
		});
	}
	const Stripe = window.Stripe || await kujiCheckoutScriptPromise;
	const stripe = Stripe(kujiStripePublishableKey);

	if (kujiCheckout) {
		kujiCheckout.destroy();
		kujiCheckout = null;
	}
	mountEl.innerHTML = '';

	clearKujiCheckoutPoll();
	if (kujiCheckoutProcessingTimer) {
		clearTimeout(kujiCheckoutProcessingTimer);
		kujiCheckoutProcessingTimer = null;
	}
	kujiCheckoutSessionId = "";
	kujiCheckoutPollToken = "";

	kujiCheckout = await stripe.initEmbeddedCheckout({
		fetchClientSecret: async () => {
			// Create the Stripe Checkout Session and keep the IDs needed for polling.
			const response = await fetch('https://raflin-server.onrender.com/api/stripe/create_checkout_session', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					shop: merchantHandle,
					currency: String(cart.currency).toLowerCase(),
					cartTotalCents: Number(cart?.total_price || 0),
					ticketPriceCents: Math.round(calc.ticket * 100),
					source: 'kuji-popup',
				}),
			});

			const data = await response.json().catch(() => ({}));
			if (!response.ok) throw new Error(data?.error || 'Unable to start checkout');
			if (!data.clientSecret) throw new Error('Checkout session missing client secret');

			kujiCheckoutSessionId = data.sessionId || "";
			kujiCheckoutPollToken = data.pollToken || "";
			return data.clientSecret;
		},
		onComplete: () => {
			if (kujiCheckout) {
				kujiCheckout.destroy();
				kujiCheckout = null;
			}

			// Start polling immediately, but only show the processing state if the
			// webhook takes long enough that the customer needs feedback.
			mountEl.innerHTML = '';
			kujiCheckoutProcessingTimer = setTimeout(() => {
				if (!kujiPopupEl?.classList.contains('kuji-stripe-active')) return;
				if (kujiPopupEl.classList.contains('kuji-stripe-result')) return;

				kujiPopupEl.classList.add('kuji-stripe-processing');
				mountEl.innerHTML = `
					<div class="kuji-checkout-state kuji-checkout-processing">
						<div class="kuji-checkout-spinner"></div>
						<h3>Processing payment</h3>
						<p>We're creating your winning ticket now.</p>
					</div>
				`;
				requestAnimationFrame(() => {
					mountEl.querySelector('.kuji-checkout-processing')?.classList.add('kuji-state-visible');
				});
			}, 1500);
			pollForTicketResult();
		},
	});
	kujiCheckout.mount('#kuji-stripe-checkout');
}

/* --------------------------- Event Delegation ----------------------------- */

document.addEventListener('click', async (e) => {
	const copyCode = e.target.closest('.kuji-ticket-copy');
	if (copyCode) {
		e.preventDefault();
		const code = String(copyCode.dataset.kujiCopyCode || '').trim();
		if (!code) return;

		try {
			if (navigator.clipboard?.writeText) {
				await navigator.clipboard.writeText(code);
			} else {
				const input = document.createElement('textarea');
				input.value = code;
				input.setAttribute('readonly', '');
				input.style.position = 'fixed';
				input.style.opacity = '0';
				document.body.appendChild(input);
				input.select();
				document.execCommand('copy');
				input.remove();
			}
			copyCode.classList.add('kuji-copied');
			setTimeout(() => copyCode.classList.remove('kuji-copied'), 1200);
		} catch (error) {
			console.warn('Kuji copy discount code failed:', error);
		}
		return;
	}

	const buyTicket = e.target.closest('.kuji-buy-ticket');
	if (buyTicket) {
		setKujiButtonLoading(buyTicket, true);
		trackMerchantAnalytics({
			step: 2,
			event: "popup_ticket_trigger",
			source: "popup_ticket_button",
			popupVariant: null,
		});

		if (kujiCheckoutMode === 'stripe') {
			e.preventDefault();

			if (kujiShowSampleCheckoutState) {
				if (kujiCheckout) {
					kujiCheckout.destroy();
					kujiCheckout = null;
				}
				clearKujiCheckoutPoll();
				if (kujiCheckoutProcessingTimer) {
					clearTimeout(kujiCheckoutProcessingTimer);
					kujiCheckoutProcessingTimer = null;
				}

				const sampleMountEl = kujiPopupEl?.querySelector('#kuji-stripe-checkout');
				const sampleCheckoutUrl = new URL('/checkout', window.location.origin);
				sampleCheckoutUrl.searchParams.set('discount', 'KUJI384BFA0511CC');

				if (sampleMountEl) {
					kujiPopupEl.classList.remove('kuji-stripe-processing');
					kujiPopupEl.classList.add('kuji-stripe-active', 'kuji-stripe-result');
					sampleMountEl.innerHTML = `
						<div id="kuji-checkout-state" class="kuji-checkout-state kuji-ticket-result">
							<div class="kuji-card kuji-result-card kuji-result-prize-card">
								<img loading="lazy" class="kuji-card-bg-logo" src="https://cdn.shopify.com/s/files/1/0728/0410/6425/files/kuji_icon_light_400x.png?v=1777851177">
								<div class="kuji-result-card-content">
									<p class="kuji-ticket-eyebrow">You won</p>
									<h3 data-kuji-result-text="10% OFF">10% OFF</h3>
									<div class="kuji-ticket-code-wrap">
										<p class="kuji-ticket-code">KUJI384BFA0511CC</p>
										<button type="button" class="kuji-ticket-copy" aria-label="Copy discount code" data-kuji-copy-code="KUJI384BFA0511CC">
											<svg viewBox="0 0 24 24" aria-hidden="true">
												<rect x="9" y="9" width="10" height="10" rx="2"></rect>
												<path d="M5 15V7a2 2 0 0 1 2-2h8"></path>
											</svg>
										</button>
									</div>
								</div>
							</div>
							<div class="kuji-card kuji-result-card kuji-result-action-card">
								<div class="kuji-result-card-content">
									<div class="kuji-btn-black">
										<a class="kuji-btn" href="${sampleCheckoutUrl.toString()}">
											<span>Apply Discount</span>
										</a>
									</div>
									<div class="kuji-btn-white">
										<button type="button" class="kuji-btn kuji-try-again">
											<span>Try Again</span>
										</button>
									</div>
								</div>
							</div>
						</div>
					`;
					requestAnimationFrame(() => {
						const resultEl = sampleMountEl.querySelector('#kuji-checkout-state');
						resultEl?.classList.add('kuji-state-visible');
						animateKujiResultState(resultEl);
					});
				}

				setKujiButtonLoading(buyTicket, false);
				return;
			}

			try {
				await openKujiCheckout();
			} catch (error) {
				console.error('Kuji checkout failed:', error);
				showKujiCheckoutError(error?.message || 'Unable to load checkout. Please try again.');
			} finally {
				setKujiButtonLoading(buyTicket, false);
			}
			return;
		}
	}

	const tryAgain = e.target.closest('.kuji-try-again');
	if (tryAgain) {
		e.preventDefault();
		setKujiButtonLoading(tryAgain, true);
		try {
			await openKujiCheckout();
		} catch (error) {
			console.error('Kuji checkout failed:', error);
			showKujiCheckoutError(error?.message || 'Unable to load checkout. Please try again.');
		} finally {
			setKujiButtonLoading(tryAgain, false);
		}
		return;
	}

	const addCartBtn = e.target.closest('.kuji-widget-cart button');
	if (addCartBtn) {
		setKujiButtonLoading(addCartBtn, true);
		trackMerchantAnalytics({
			step: 1,
			event: "popup_trigger",
			source: "cart_page_button",
		});

		// to do: might be a good idea to move the openKuji event here rather than added to the button
		//openKuji(trigger.dataset.kujiSource || 'Cart', { recheck:false });
	}

	const addProductBtn = e.target.closest('.kuji-add-product');
	if (addProductBtn) {
		e.preventDefault();
		const analyticsPayload = {
			step: 1,
			event: "popup_trigger",
			source: "product_page_button",
		};

		if (addProductBtn.dataset.kujiCtaReady === 'true') {
			analyticsPayload.ctaVariant = addProductBtn.dataset.kujiMessageVariant || null;
			analyticsPayload.ticketPrice = addProductBtn.dataset.kujiTicketPrice || null;
			analyticsPayload.productVariantId = addProductBtn.dataset.kujiVariantId || null;
		}

		trackMerchantAnalytics(analyticsPayload);

		setKujiButtonLoading(addProductBtn, true);

		(async () => {
			// Snapshot current cart total BEFORE adding
			let prevTotal = 0;
			try {
				const before = await getCart(); // { total_price, ... }
				prevTotal = Number(before?.total_price || 0);
			} catch (err) {
				console.warn('Failed to read cart before add:', err);
			}

			const configuredProductTarget = getConfiguredProductTarget(addProductBtn);

			if (configuredProductTarget) {
				configuredProductTarget.click();
			} else {
				// Find and submit nearby /cart/add form
				let el = addProductBtn;
				let productFormSubmit = null;
				while (el && el !== document.documentElement) {
					const forms = el.querySelectorAll('form[action="/cart/add"]');
					for (const form of forms) {
						const submit = form.querySelector([
							'button[type="submit"]',
							'button:not([type])',
							'input[type="submit"]',
							'button[name="add"]',
							'[type="submit"][name="add"]',
							'[data-add-to-cart]',
							'.product-form__submit',
							'.product-form-submit',
							'.add-to-cart',
							'[aria-label*="add to cart" i]',
							'[aria-label*="add-to-cart" i]'
						].join(','));
						if (submit) { productFormSubmit = submit; break; }
					}
					if (productFormSubmit) break;
					el = el.parentElement;
				}

				productFormSubmit?.click();
			}

			Cookies.set('kuji-added', 'yes', 1);

			// Open popup and start “wait until total changes” loop
			openKuji('Product', { prevTotal });
		})().catch((err) => {
			console.error('Kuji product flow failed:', err);
			setKujiButtonLoading(addProductBtn, false);
		});

		return;
	}

	const infoBtn = e.target.closest('.kuji-info-btn');
	if (infoBtn) {
		e.preventDefault();
		openKujiInfo('Popup');
		return;
	}

	const closeBtn = e.target.closest('[data-kuji-close]');
	if (closeBtn) {
		const which = closeBtn.getAttribute('data-kuji-close');
		if (which === 'main' && kujiPopupEl) closeKuji(kujiPopupEl);
		if (which === 'promo' && kujiPromoEl) closeKuji(kujiPromoEl);
		if (which === 'info' && kujiInfoEl) closeKuji(kujiInfoEl);
		if (which === 'hiw' && kujiHIWEl) closeKuji(kujiHIWEl);
		safeGAEvent('Close Popup', which);
		return;
	}

	const popup = e.target.classList.contains('kuji-popup') ? e.target : null;
	if (popup) {
		closeKuji(popup);
		safeGAEvent('Close Popup', 'External');
		return;
	}

	const moreInfo = e.target.closest('.kuji-more-info');
	if (moreInfo) {
		const popup = moreInfo.closest('.kuji-popup');
		const moreInfoSteps = popup?.querySelector('.kuji-popup-steps');
		const contShopping = popup?.querySelector('.kuji-cont-shopping');

		if (moreInfoSteps) {
			moreInfo.style.display = 'none';
			contShopping?.style.setProperty('display', 'flex');
			moreInfoSteps.style.maxHeight = '1000px';
			safeGAEvent('More Info', 'Click');
		}
		return;
	}
});

/* --------------------------- Promo Triggers ------------------------------- */

(function promoTriggers() {
	//console.log('promoTriggers');
	//console.log('kujiStatus',kujiStatus);
	//console.log('kuji-ab',Cookies.get('kuji-ab'));

	if (!kujiStatus || Cookies.get('kuji-ab') !== '1' || isDesignMode) return;

	if (window.location.pathname === '/cart' && Cookies.get('kuji-added') === 'yes') {
		openKuji('Cart Page', { recheck:false });
		Cookies.delete('kuji-added');
	}

	//console.log('typeof window.kuji_promo_timer',typeof window.kuji_promo_timer);

	// (Cookies.get('kuji-seen') !== 'yes'
	if (Cookies.get('kuji-seen') !== 'true' && typeof window.kuji_promo_timer !== 'undefined') {

		console.log('view kuji popup');
		let popupTriggered = false;

		setTimeout(() => {
			if (!popupTriggered) {
				openKujiPromo('Timed');
				popupTriggered = true;
			}
		}, Number(window.kuji_promo_timer) || 22000);

		document.addEventListener('mouseleave', (event) => {
			if (popupTriggered) return;
			if (event.clientY <= 0 || event.clientX <= 0 || (event.clientX >= window.innerWidth || event.clientY >= window.innerHeight)) {
				openKujiPromo('Exit');
				popupTriggered = true;
			}
		});
	}

	if (kujiPreview.kuji_popup === 'true') {
		buildMainPopup();
		updateKuji('popup');
	}
})();


/* ------------------------- Widget Builder ------------------------- */

// “Empty” => no child elements (ignores whitespace text nodes)
function kujiIsEmpty(el) { return !el || el.childElementCount === 0; }

/**
 * Build the correct Kuji button markup into a widget container.
 * - For .kuji-widget-cart: renders cart CTA + "OR"
 * - For .kuji-widget-product: renders "OR" + product CTA, and matches width to add-to-cart submit
 */
function buildKujiBtn(widget) {
	if (!widget) return;

	const isProduct = widget.classList.contains('kuji-widget-product');
	const isCart    = widget.classList.contains('kuji-widget-cart');

	// Compute price text if provided for nicer display (optional; not required for your given markup)
	const productPriceCents = Number(widget.getAttribute('data-price') || 0);
	let info = null;
	if (productPriceCents) info = calculateTicket(productPriceCents);

	// --- CART WIDGET MARKUP (button then "OR") ---
	if (isCart) {
		if ( kujiIsEmpty(widget) ) {

			widget.innerHTML = `
		<div class="kuji-or-header">OR</div>
		<button class="kuji-trigger kuji-btn kuji-brand-btn" type="button" name="kuji-checkout" aria-label="kuji Checkout" onclick="openkuji('Open Popup','Cart',false)">
			<span>WIN YOUR CART</span> <span class="small-with">with</span>
			<img loading="lazy" width="28" height="12" src="${KujiLogoSmall}" alt="kuji logo">
		</button>`;
		}
	}

	// --- PRODUCT WIDGET MARKUP ("OR" then button) ---
	if (isProduct) {
		if ( kujiIsEmpty(widget) ) {

			widget.innerHTML = `
			<div class="kuji-or-header">OR</div>
			<button class="kuji-add-product kuji-btn kuji-brand-btn" type="button">
				<span class="buy-now">WIN IT NOW</span> <span class="small-with">with</span>
				<img loading="lazy" width="28" height="12" src="${KujiLogoSmall}" alt="kuji logo">
			</button>`;

		}
		if (isDesignMode && !kujiStatus) {
			widget.insertAdjacentHTML(
				"beforeend",
				`
				<div class="kuji-status-message">
					<p><strong>Status: Draft</strong></p>
					<p>Kuji is only visible in the theme editor.
					<p><a href="https://admin.shopify.com/store/${merchantHandle}/apps/kuji-now/app/install">Customise button</a>.</p>
				</div>
				`
			);
		}

		// For variable CTA testing:
		const productButton = widget.querySelector('.kuji-add-product');
		if (productButton) {
			if (productButton.dataset.kujiCtaInit !== 'true') {
				productButton.dataset.kujiCtaInit = 'true';
				updateProductButton(productButton);
				bindProductButtonEvents(productButton);
			}
		}
	}
	widget.style.visibility = 'visible';

	// Button last active tracking
	const now = Date.now();
	let update_active = true;

	if (kuji.last_active) {
		const lastActive = new Date(kuji.last_active).getTime();
		const oneHour = 60 * 60 * 1000;

		if (now - lastActive < oneHour) {
			update_active = false;
		}
	}

	if (update_active){
		fetch("/apps/kuji-proxy/last_active", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
		});
	}
}


// Used for Variable Product Button CTA and Win for $X messaging:
function bindProductButtonEvents(button) {
	if (!button || button.dataset.kujiBound === 'true') return;
	button.dataset.kujiBound = 'true';

	const form = getNearestProductForm(button);
	const quantityInput = getNearestQuantityInput(button, form);

	const update = () => {
		window.requestAnimationFrame(() => {
			updateProductButton(button);
		});
	};

	// watch for  product form updates:
	if (form) {
		form.addEventListener('change', update);
		form.addEventListener('input', update);
	}

	if (quantityInput) {
		quantityInput.addEventListener('change', update);
		quantityInput.addEventListener('input', update);

		const quantityWrapper = quantityInput.closest(
			'quantity-input, .quantity, .quantity__input, .quantity-selector, .product-form__quantity'
		);

		if (quantityWrapper) {
			quantityWrapper.addEventListener('click', update);
		}
	}

	//compatibility with themes that emit variant:change
	document.addEventListener('variant:change', update);

	update();
}

/* Hydrate any empty Kuji widgets (both types) in a container */
function hydrateKujiWidgets(container = document) {
	//console.log('hydrating');
	container.querySelectorAll('.kuji-widget-cart, .kuji-widget-product').forEach((w) => {
		buildKujiBtn(w);
	});
}

function trackMerchantAnalytics({ step, event, source = null, ctaVariant = null, ticketPrice = null,
 productVariantId = null, popupVariant = null,
}) {
	try {
		fetch("/apps/kuji-proxy/analytics_event", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				step,
				event,
				source,
				ctaVariant,
				ticketPrice,
				productVariantId,
				popupVariant,
			}),
			keepalive: true,
		});
	} catch (_) {}
}

/* --------------------------- Check Kuji Status -------------------------- */

function shouldInitKuji() {
	if (kujiStatus && Cookies.get('kuji-ab') === '1') return true;
	if (Cookies.get('kuji-preview') === 'true' || kujiPreview?.kuji === 'true' || isDesignMode) return true;
	return false;
}

/* --------------------- Widget Observer  ---------------- */

/* Observers full dom changes - disabled in preference for a simple fetch/jQuery AJAX add to cart observer
// Checks for new Kuji widgets (eg. cart drawer updated from empty cart messaging)*/
function attachKujiWidgetObserver() {
	if (isDesignMode) return;

	const target = document.body || document.documentElement;
	if (!target) return;

	let raf = 0;
	const mo = new MutationObserver(() => {
		if (raf) cancelAnimationFrame(raf);
		raf = requestAnimationFrame(() => {
			raf = 0;
			refreshKujiWidgets(document);
		});
	});

	mo.observe(target, { childList: true, subtree: true });
}

/* Built to replace the observer which worked for add to cart, but we need this for popup adds too
//Check for ajax add to cart
function watchFetchAddToCart() {
	// Only watch once
	if (window.__kuji_cart_add_hooked) return;
	window.__kuji_cart_add_hooked = true;

	if (!window.fetch) return;

	const originalFetch = window.fetch;

	window.fetch = async function (...args) {
		const response = await originalFetch.apply(this, args);

		try {
			const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;

			// check for '/cart/add' and '/cart/add.js'
			if (url && /\/cart\/add(\.js)?(\?|$)/.test(url)) {

				// Cart just went from empty → not empty
				requestAnimationFrame(() => hydrateKujiWidgets(document));
				// optional if theres issues with cart draw rendering:
				//requestAnimationFrame(() => {
					//requestAnimationFrame(() => hydrateKujiWidgets(document));
				//});
			}
		} catch (_) {}

		return response;
	};
}*/

function watchAjaxAddToCart () {
	if (window.__kuji_cart_add_xhr_hooked) return;
	window.__kuji_cart_add_xhr_hooked = true;

	const origOpen = XMLHttpRequest.prototype.open;
	const origSend = XMLHttpRequest.prototype.send;

	XMLHttpRequest.prototype.open = function (method, url, ...rest) {
		this.__kuji_url = url;
		return origOpen.call(this, method, url, ...rest);
	};

	XMLHttpRequest.prototype.send = function (...args) {
		this.addEventListener('load', () => {
			try {
				if (this.__kuji_url && /\/cart\/add(\.js)?(\?|$)/.test(this.__kuji_url)) {
					requestAnimationFrame(() => refreshKujiWidgets(document));
				}
			} catch (_) {}
		});

		return origSend.apply(this, args);
	};
}

/* --------------------------- Auto-inject Kuji widget -------------------------- */

/**
 * Add Kuji buttons to product ATC forms that don't have one.
 * Call on DOMContentLoaded + after known cart/product sections re-render.
 */
function autoAddKujiWidgets(container = document) {
	if (!kujiProduct?.id) return; // Don't display on collection pages for now

	if (kujiSelectors.product_page) {
		let insertedConfiguredWidget = false;

		try {
			const targets = container.querySelectorAll(kujiSelectors.product_page);

			targets.forEach((target) => {
				if (!target || target.classList?.contains('kuji-widget')) return;

				if (!target.dataset.kujiProductTargetId) {
					kujiProductTargetCounter += 1;
					target.dataset.kujiProductTargetId = `kuji-product-target-${kujiProductTargetCounter}`;
				}

				const targetId = target.dataset.kujiProductTargetId;
				const existingWidget = document.querySelector(`.kuji-widget-product[data-kuji-product-target-id="${targetId}"]`);
				if (existingWidget) {
					insertedConfiguredWidget = true;
					return;
				}

				const widgetWrapper = document.createElement('div');
				const styles = getComputedStyle(target);
				const borderRadius = styles.borderRadius.replace('px','') * 1;
				let radiusClass = '';
				if (borderRadius == 0) radiusClass = ' kuji-square';
				else if (borderRadius > 10) radiusClass = ' kuji-round';

				widgetWrapper.className = `kuji-widget-product kuji-widget kuji-auto${radiusClass}`;
				widgetWrapper.dataset.kujiProductTargetId = targetId;

				if (!target.parentNode) return;

				target.insertAdjacentElement('afterend', widgetWrapper);

				try {
					buildKujiBtn(widgetWrapper);
					insertedConfiguredWidget = true;
				} catch (e) {
					console.warn('[Kuji] buildKujiBtn failed for configured product target', e);
				}
			});
		} catch (error) {
			console.warn('[Kuji] Invalid product_page selector', error);
		}

		if (insertedConfiguredWidget) return;
	}

	const forms = container.querySelectorAll('form[action]');

	forms.forEach((form) => {
		const action = (form.getAttribute('action') || '').trim().toLowerCase();

		// Match Shopify cart add endpoints ('/cart/add', '/cart/add.js' etc)
		if (!action.includes('/cart/add')) return;

		// Skip if form already contains any Kuji widget wrapper
		if (form.querySelector('.kuji-widget')) return;

		// Needs a submit control (avoid non-ATC forms)
		const submitBtn =
			form.querySelector('button[type="submit"], input[type="submit"]');
		if (!submitBtn) return;

		const widgetWrapper = document.createElement('div');
		const styles = getComputedStyle(submitBtn);
		const borderRadius = styles.borderRadius.replace('px','') * 1;
		let radiusClass = '';
		if (borderRadius == 0) radiusClass = ' kuji-square';
		else if (borderRadius > 10) radiusClass = ' kuji-round';
		widgetWrapper.className = `kuji-widget-product kuji-widget kuji-auto${radiusClass}`;

		// Insert immediately after submit if possible, else at end of form
		if (submitBtn.parentNode) {
			submitBtn.insertAdjacentElement('afterend', widgetWrapper);
		} else {
			form.appendChild(widgetWrapper);
		}

		try {
			buildKujiBtn(widgetWrapper);
		} catch (e) {
			console.warn('[Kuji] buildKujiBtn failed for auto wrapper', e);
		}
	});
}

function autoAddKujiCartWidget(container = document) {

	// Cart Pages
	let cartFormsSelectors = 'form[action="/cart"]';

	// Server DB values
	if (kujiSelectors.cart_page) {
		cartFormsSelectors = kujiSelectors.cart_page;
	}

	let formClasses = 'kuji-widget-cart kuji-widget';
	if (kuji.btn_style) {
		formClasses += ` kuji-${kuji.btn_style}`;
	}
	if (kuji.btn_radius) {
		formClasses += ` kuji-${kuji.btn_radius}`;
	}

	const cartForms = container.querySelectorAll(cartFormsSelectors);
	cartForms.forEach((form) => {
		const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');

		if (!submitBtn) return;

		// Skip if we already inserted a cart widget for this checkout form.
		if (form.querySelector('.kuji-widget-cart.kuji-widget')) return;

		const widgetWrapper = document.createElement('div');
		widgetWrapper.className = formClasses;

		if (submitBtn.parentNode) {
			submitBtn.insertAdjacentElement('afterend', widgetWrapper);
		} else {
			form.appendChild(widgetWrapper);
		}

		try {
			buildKujiBtn(widgetWrapper);
		} catch (error) {
			console.warn('[Kuji] buildKujiBtn failed for cart form widget', error);
		}
	});

	// Cart Drawers - auto add if defined
	if (kujiSelectors.cart_drawer) {

		const target = container.querySelector(kujiSelectors.cart_drawer);
		if (target && !target.nextElementSibling?.classList?.contains('kuji-widget-cart')) {
			const widgetWrapper = document.createElement('div');
			widgetWrapper.className = formClasses;
			target.insertAdjacentElement('afterend', widgetWrapper);
			try {
				buildKujiBtn(widgetWrapper);
			} catch (error) {
				console.warn('[Kuji] buildKujiBtn failed for cart drawer widget', error);
			}
		}
	}
}

function refreshKujiWidgets(container = document) {
	autoAddKujiWidgets(container);
	autoAddKujiCartWidget(container);
	hydrateKujiWidgets(container);
}


/* --------------------------- INIT -------------------------- */

function initKujiWidgets(container = document) {
	document.body.classList.add('kuji-enabled');

	if (kuji.btn_style != "" && kuji.btn_style != 'default'){
		document.body.classList.add(`kuji-btn-${kuji.btn_style}`);
	}

	refreshKujiWidgets(container);
}

/* --------------------------- Boot -------------------------- */

// Page load


document.addEventListener('DOMContentLoaded', () => {

	if (!shouldInitKuji()) return;

	initKujiWidgets(document);
	attachKujiWidgetObserver();
	watchAjaxAddToCart();

	if (!isDesignMode) {
		setTimeout(() => {
			const ab = Cookies.get('kuji-ab');
			if (!ab) return;
			const val = (ab === '1') ? 'With kuji' : 'Without kuji';
			safeMP('A/B Split', { Action: 'Page View', Value: val, Merchant: merchantHandle });
			safeGAEvent('A/B Split', 'Visit');
		}, 1000);
	}
});

// Theme editor sections
document.addEventListener('shopify:section:load', (e) => {
	if (!shouldInitKuji()) return;
	initKujiWidgets(e.target);
});

/*
// Reserved for later if needed
document.addEventListener('shopify:section:unload', () => {});
document.addEventListener('shopify:block:select', () => {});
document.addEventListener('shopify:block:deselect', () => {});
*/


/* ------------------------------ Public API -------------------------------- */

window.Kuji = window.Kuji || {
	open: (label='Cart', opts={}) => openKuji(label, opts),
	openInfo: openKujiInfo,
	openHIW: openKujiHIW
};


window.addEventListener("load", () => {
	const privacy = window.Shopify?.customerPrivacy;

	/*
	console.log("[Kuji consent on load]", {
		analyticsAllowed: privacy?.analyticsProcessingAllowed?.(),
		marketingAllowed: privacy?.marketingAllowed?.(),
		saleOfDataAllowed: privacy?.saleOfDataAllowed?.(),
	});*/
});
